import React from "react";
import {Box,
        Button,
        createStyles,
        IconButton,
        makeStyles,
        Theme,
        Typography,
        AppBar,
        Link,
        Slide,
        Toolbar} from "@material-ui/core";
import {Registration, ThinkTankContent} from "../../models/models";
import LinkedIn from "../../resources/images/linkedin.svg";
import {openLinkedInProfile} from "../../utils/linkedin";
import {useHistory} from "react-router";
import {BusinessPartnerMeta} from "../../models/models";
import {SponsorCarousel} from './SponsorCarousel';
import Config from "../../config";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: 'center',
        position: 'fixed',
        width: '100%',
        backgroundColor: "#7f837e",
//backgroundColor: theme.palette.primary.main
        top: "auto",
        bottom: 0,
        left: 0
      },
      logoBanner: {
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 5,
        paddingBottom: 5,
        flex: 1,
        display: "flex",
        flexDirection: "row",
        justifyContent: 'center',
        gap: '10%',
        width: '80%',
        margin: 'auto'
      },
      spacer: {
        minHeight: 60
      },
      logoContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      },
      logoImg: {
        height: 30
      },
      brandName: {
        maxWidth: 60,
        border: '2px solid',
        borderRadius: 10
      }
    }
  )
);

export interface SponsorBannerProps {
    businessPartners: BusinessPartnerMeta[];
}

const visibleCount = 3;

export const SponsorBanner: React.FC<SponsorBannerProps> = ({businessPartners}) => {
    const classes = useStyles();

    if(!businessPartners ||
       !Array.isArray(businessPartners) ||
       businessPartners.length === 0) return null

    const normalizeUrl = (url: string) => {
      if(!url) return null
      if(!/^https?:\/\//i.test(url)) {
        return `https://${url}`;
      }
      return url;
    }

    const effectiveVisibleCount = Math.min(visibleCount, businessPartners.length);


    return (
      <>
      <Box className={classes.spacer}/>

      <AppBar position="fixed" className={classes.container}>
        <Typography variant="body2" color="textSecondary">
          {businessPartners.length === 1 ? 'Branding Partner:' : 'Branding Partners:'}
        </Typography>
        <SponsorCarousel
          businessPartners={businessPartners}
        />

        {/*

          <Toolbar className={classes.logoBanner}>
             {
               businessPartners.map((thisBusinessPartner) => {
                 const base_url = Config.getInstance().getCoordinationServiceURL()
                 const logo_path = `${base_url}/api/serve_logo/${thisBusinessPartner.logo}`

                 const external_url = normalizeUrl(thisBusinessPartner.homepageUrl);

                 return (
                   <Box
                     component="a"
                     key={`logoContainer-${thisBusinessPartner.id}`}
                     className={classes.logoContainer}
                     rel="noopener noreferrer"
                     target="_blank"
                     href={external_url}
                   >
                     <img
                       className={classes.logoImg}
                       alt={thisBusinessPartner.name}
                       src={logo_path}
                     />
                  </Box>
                )
              })
            }
        </Toolbar>
        */}

      </AppBar>
      </>
    )

  }
